import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC } from 'react';
import kioskEditStore from '../../store/kioskEditStore';
import { localeStore } from '~/mobx/localesStore';
import { getTranslate } from '~/utils/helpers';
import Text, { TEXT } from '~/view/components/Text/Text';
import { IBranchesModalItem } from '~/view/containers/Modals/BranchesModal/BranchesModal';
import BranchesModalOpen from '~/view/containers/Modals/BranchesModal/components/BranchesModalOpen/BranchesModalOpen';
import './style.scss';

const KioskBranch: FC = observer((): JSX.Element => {
  const handleBranchChange = (branches: IBranchesModalItem[]) => {
    const selectedBranch = branches?.[0];

    if (!selectedBranch) return;

    kioskEditStore.changeEditableKiosk({ branchId: selectedBranch.id.toString(), branchName: getTranslate(selectedBranch.name) });
    kioskEditStore.validateBranch();
  };

  const branchError = kioskEditStore.errorMessages.branch;

  return (
    <div className="kiosk__field">
      <Text type="order-field" text="txt_branch" required className="kiosk__field-title" />

      <div className="d-flex flex-column kiosk-branch">
        <BranchesModalOpen
          selectedBranches={[
            {
              id: +kioskEditStore.editableKiosk.branchId,
              name: { en: kioskEditStore.editableKiosk.branchName, ar: kioskEditStore.editableKiosk.branchName },
            },
          ]}
          className={classNames({ 'input-error': branchError })}
          showIconPlaceholder
          saveWithoutBranches
          onSave={handleBranchChange}
        />
        {branchError ? <Text text={localeStore.t(branchError)} type={TEXT.ERROR} /> : null}
      </div>
    </div>
  );
});

export default KioskBranch;
